import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  return (
    <Link
      to={`/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group flex flex-col bg-white border border-[#E2E0D8] rounded-xl overflow-hidden hover:border-[#D95D2E] hover:shadow-lg transition-all duration-300"
    >
      <div className="relative aspect-[16/10] overflow-hidden tf-img-zoom bg-[#1B2A1E]">
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="font-heading text-xl font-bold text-[#1B2A1E] mb-2 group-hover:text-[#D95D2E] transition-colors">
          {service.title}
        </h3>
        <p className="text-[15px] text-[#3a4338] leading-relaxed flex-1">
          {service.short}
        </p>
        <div className="mt-5 inline-flex items-center gap-1.5 text-[#D95D2E] font-semibold text-sm">
          Läs mer
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
